<div class="container content-box module-content">
    <div class="text-center">
        <h1>Activity</h1>
    </div>
    <hr>
    <h4>Description</h4>
    <p>This activity will help you practice comparing three housing units. For this activity you will compare housing units and decided which of the three units suits Nancy and her needs best. More information can be found in the activity handout
        below.</p>
    <h4>Instructions</h4>
    <ol class="instructions-list">
        <li class="instructions-item">Download the activity handout by clicking the "Download Handout" button below</li>

    </ol>
    <div class="text-center">
        <button type="button" class="btn waves-dark w-25" (click)="downloadHandoutPdf(); content.downloaded = true" [class.invalid]="content.validate && !content.downloaded">Download Handout</button>

        <div class="invalid-feedback d-block" *ngIf="content.validate && !content.downloaded">
          Download and review handout first.
        </div>
    </div>

</div>

<div class="container navigate-buttons">
    <button type="button" class="btn waves-dark w-25" (click)="goBack($event)"><i class="fas fa-angle-left mr-3"></i>{{backTitle}}</button>
    <button type="button" class="btn waves-dark w-25" (click)="previewByAdmin || !delay || content.downloaded ? goNext($event) : content.validate = true" [delay-click]="delay ? 10 : 0" [delay-tooltip]="true">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
</div>
